import React, { useState, useEffect } from "react";
import { getFirestore, collection, getDocs, orderBy, query, doc, deleteDoc } from "firebase/firestore";
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { StyledTableCell, StyledTableRow } from '../../utils/styled'
import { Typography } from "@mui/material";

const firestore = getFirestore();

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function ListHerramientas() {
    const [herramientas, setHerramientas] = useState([]);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [herramientaToDelete, setHerramientaToDelete] = useState(null);
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });

    useEffect(() => {
        getHerramientas();
    }, []);

    const getHerramientas = async () => {
        try {
            const q = query(collection(firestore, "herramientas"), orderBy("id", "asc"));
            const querySnapshot = await getDocs(q);
            const herramientasData = [];
            querySnapshot.forEach((doc) => {
                herramientasData.push({ ...doc.data(), docId: doc.id });
            });
            setHerramientas(herramientasData);
        } catch (error) {
            console.error("Error al obtener herramientas:", error);
            setSnackbarInfo({ text: 'Error al cargar herramientas', type: 'error', open: true });
        }
    };

    const handleClose = () => {
        setOpenDeleteModal(false);
    };

    const deleteHerramienta = async () => {
        try {
            const docRef = doc(firestore, 'herramientas', String(herramientaToDelete));
            await deleteDoc(docRef);
            setSnackbarInfo({ text: 'Eliminado correctamente!', type: 'success', open: true });
            setOpenDeleteModal(false);
            setTimeout(() => {
                window.location.reload();
            }, 2500);
        } catch (error) {
            console.log('error', error);
            setOpenDeleteModal(false);
            setSnackbarInfo({ text: 'Ocurrió un error', type: 'error', open: true });
        }
    };

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    return (
        <Container component="main" maxWidth="xl">
            <Typography variant="h5">Listado de herramientas (Catálogo)</Typography>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <Button variant="contained" href="/add-herramienta">Nueva</Button>
            </div>
            <TableContainer>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Id</StyledTableCell>
                            <StyledTableCell>Códigos</StyledTableCell>
                            <StyledTableCell>Nombre</StyledTableCell>
                            <StyledTableCell>Acciones</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {herramientas && herramientas.map((herramienta, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell>{herramienta.id}</StyledTableCell>
                                <StyledTableCell>{herramienta.codigos}</StyledTableCell>
                                <StyledTableCell>{herramienta.name || herramienta.nombre}</StyledTableCell>
                                <StyledTableCell className="column-actions">
                                    <IconButton
                                        aria-label="edit"
                                        className="action__link"
                                        href={`/herramienta/${herramienta.id}`}
                                        role="button"
                                    >
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        aria-label="delete"
                                        type="button"
                                        className="action__button"
                                        onClick={() => {
                                            setOpenDeleteModal(true);
                                            setHerramientaToDelete(herramienta.id);
                                        }}
                                    >
                                        <DeleteIcon sx={{ color: 'red' }} />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={openDeleteModal}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"¿Desea eliminar esta herramienta?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Los cambios serán permanentes.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cerrar</Button>
                    <Button onClick={deleteHerramienta} autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default ListHerramientas;
